import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ChangePassword from "./pages/login/changePassword.jsx";
import DashboardMain from "./pages/dashboard/dashboardMain.jsx";
// import LeftMenu from "./pages/dashboard/leftMenu";
import Blacklist from "./pages/blacklist/blacklist.jsx";
import CandidateBlackListInfo from "./pages/blacklist/CandidateBlackListInfo.jsx";
import CreateBlackList from "./pages/blacklist/CreateBlackList.jsx";
import SettingsHomePage from "./pages/Settings/SettingsHomePage.jsx";
import CreateInterview from "./pages/schedule/createInterview.jsx";
import Search from "./pages/dashboard/search.jsx";
import SearchResults from "./pages/dashboard/searchResults.jsx";
import ResumeUpload from "./pages/fileUpload/resumeUpload.jsx";
import ResumeUploadHomePage from "./pages/fileUpload/ResumeUploadHomePage.jsx";
import ResumeBulkUpload from "./pages/fileUpload/resumeBulkUpload.jsx";
import Signup from "./pages/login/signUp.jsx";
import Validate from "./pages/dashboard/validates.jsx";
import Profile from "./pages/dashboard/profile.jsx";
import SearchResult from "./pages/dashboard/searchResult.jsx";
import AdminSettings from "./pages/dashboard/adminSettings.jsx";
import Process from "./pages/leads/process.jsx";
import InitialProcess from "./pages/leads/initialProcess.jsx";
import Designations from "./pages/leads/newRequirement/Designations.jsx";
import Departments from "./pages/leads/Departments/Departments.jsx";
import AssignRecruiter from "./pages/leads/assignRecruiter.jsx";
import ViewMatching from "./pages/leads/viewMatching.jsx";
import ListTables from "./pages/leads/listTables.jsx";
import Candidate from "./pages/leads/candidate-profile.jsx";
import CandidateProfile from "./pages/leads/candidate-profile.jsx";
import JobHistory from "./pages/schedule/newRequirement/jobOpeningHistory.jsx";
import ViewMatchings from "./pages/leads/viewMatchingRecruiters.jsx";
import ApplyNow from "./apply-now/applyNow.jsx";
import SiteSettings from "./pages/dashboard/siteSettings.jsx";
import OpeningBulkUpload from "./components/components/bulkUpload.jsx";
import OnBoarding from "./pages/dashboard/onBoarding.jsx";
import CandidateStatus from "./pages/dashboard/candidate-status.jsx";
import CandidateStatusOrder from "./pages/dashboard/candidate-status-order.jsx";
import Home from "./pages/home.jsx";
import HomePage from "./pages/home/home-page.jsx";
import CandidateLogin from "./pages/login/candidateLogin.jsx";
import EmployerLogin from "./pages/login/employerLogin.jsx";
import CandidateDashboard from "./pages/dashboard/candidate-dashboard.jsx";
import Register from "./pages/login/register.jsx";
import Otp from "./pages/login/otp.jsx";
import CandidateSignup from "./pages/login/candidateSignup.jsx";
import CandidateResumeUpload from "./pages/candidate/candidate-resume-upload.jsx";
import CandidateSchedule from "./pages/candidate/candidate-schedule.jsx";
import CandidateApplied from "./pages/candidate/candidate-applied.jsx";
import AssessmentHomePage from "./pages/candidate/Assessment/AssessmentHomePage.jsx";
import CandidateAssessment from "./pages/candidate/Assessment/candidate-assessment.jsx";
import Evaluation from "./pages/schedule/evaluation/evaluation.jsx";
import NewRequirement from "./pages/leads/new-requirement.jsx";
import SchedulesMain from "./pages/schedule/schedulesMain.jsx";
import RequirementProcessing from "./pages/leads/newRequirement/requirementProcessing.jsx";
import NewRequirmentMainPage from "./pages/schedule/newRequirement/newRequirmentMainPage.jsx";
import Reports from "./pages/home/reports/reports.jsx";
import AnalyticsReport from "./pages/home/reports/analytics-report.jsx";
import AnalyticsDashboard from "./pages/dashboard/AnalyticsDashboard/dashboard.jsx";
import AnalyticsDashboardTwo from "./pages/dashboard/Dashboard2/DashboardTwo.jsx";
import Skillset from "./pages/leads/SkillSet/Skillset.jsx";
import ReportHomepage from "./pages/leads/Report/ReportHomepage.jsx";
import SourceReport from "./pages/home/reports/SourceReport.jsx";
import AgeingHomepage from "./pages/leads/Report/AgeingHomepage.jsx";
import IntervewTypeReport from "./pages/home/reports/IntervewTypeReport.jsx";
import CloneRequirement from "./pages/leads/CloneRequirement.jsx";
export default function RouteList() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Home Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/:siteId" element={<HomePage />} />

        {/* Login Routes and Signup */}
        <Route path="/candidateLogin" element={<CandidateLogin />} />
        <Route path="/employerLogin" element={<EmployerLogin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/candidateSignup" element={<CandidateSignup />} />
        <Route path="/register" element={<Register />} />
        <Route path="/otp" element={<Otp />} />
        {/* Password and Initial Setup */}
        <Route path="/changePassword" element={<ChangePassword />} />
        <Route path="/initialProcess" element={<InitialProcess />} />
        <Route path="/Designations" element={<Designations />} />
        <Route path="/Departments" element={<Departments />} />

        {/*Blacklist Process */}
        <Route path="/Blacklist" element={<Blacklist />} />
        <Route path="/CandidateBlackListInfo" element={<CandidateBlackListInfo />} />
        <Route path="/CreateBlackList" element={<CreateBlackList />} />


        {/* Candidate and Recruiter Process */}
        <Route path="/assignRecruiter" element={<AssignRecruiter />} />
        <Route path="/viewMatching" element={<ViewMatching />} />
        <Route path="/process" element={<Process />} />
        <Route path="/candidateprofile" element={<Candidate />} />
        <Route path="/Skillset" element={<Skillset />} />
        <Route path="/Report" element={<ReportHomepage />} />
        <Route path="/SourceReport" element={<SourceReport />} />
        <Route path="/AgeingReport" element={<AgeingHomepage />} />
        <Route path="/IntervewTypeReport" element={<IntervewTypeReport />} />

        {/* Dashboard */}
        <Route path="/dashboard/dashboardMain" element={<DashboardMain />} />
        <Route
          path="/candidate-resume-upload"
          element={<CandidateResumeUpload />}
        />
        <Route path="/validate/:secretKey/:accessKey" element={<Validate />} />
        <Route path="/dashboard/search" element={<Search />} />
        <Route path="/dashboard/searchResults" element={<SearchResults />} />
        <Route path="/schedule/createInterview" element={<CreateInterview />} />
        <Route path="/openings/uploadResumes" element={<OpeningBulkUpload />} />
        <Route
          path="/schedule/createJobOpening"
          element={<NewRequirmentMainPage />}
        />
        <Route path="/CloneRequirement" element={<CloneRequirement />} />
        <Route
          path="/fileUpload/resumeUpload"
          element={<ResumeUploadHomePage />}
        />
        <Route
          path="/fileUpload/resumeBulkUpload"
          element={<ResumeBulkUpload />}
        />
        <Route path="/dashboard/profile" element={<Profile />} />
        <Route path="/dashboard/searchResult" element={<SearchResult />} />
        <Route path="/dashboard/adminSettings" element={<AdminSettings />} />
        <Route path="/dashboard/siteSettings" element={<SiteSettings />} />
        <Route path="/dashboard/Settings" element={<SettingsHomePage />} />
        <Route path="/dashboard/profile" element={<Profile />} />
        <Route path="/dashboard/reports" element={<Reports />} />
        <Route
          path="/dashboard/reports/analytics-reports"
          element={<AnalyticsReport />}
        />
        <Route path="/schedule/schedules" element={<SchedulesMain />} />
        <Route
          path="/candidateprofile/:candidateId?"
          element={<CandidateProfile />}
        />
        <Route path="/candidate/candidateEvaluation" element={<Evaluation />} />
        <Route path="/tables" element={<ListTables />} />
        <Route path="/jobHistory" element={<JobHistory />} />
        <Route path="/viewMatchingRecruiters" element={<ViewMatchings />} />
        <Route path="/careers/:siteId" element={<ApplyNow />} />
        <Route path="/careers/:jobId/:siteId" element={<ApplyNow />} />
        <Route path="/onBoard" element={<OnBoarding />} />
        <Route
          path="/dashboard/candidateStatus"
          element={<CandidateStatus />}
        />
        <Route
          path="/dashboard/CandidateStatusOrder"
          element={<CandidateStatusOrder />}
        />
        <Route
          path="/dashboard/candidateDashboard"
          element={<CandidateDashboard />}
        />
        <Route path="/candidate-schedule" element={<CandidateSchedule />} />
        <Route path="/candidate-applied" element={<CandidateApplied />} />
        <Route path="/candidate-assessment" element={<CandidateAssessment />} />
        <Route
          path="/candidate-assessmentHomePage"
          element={<AssessmentHomePage />}
        />

        <Route path="/dashboard/new-requirement" element={<NewRequirement />} />
        <Route
          path="/new-requirement/processing"
          element={<RequirementProcessing />}
        />
        <Route
          path="/dashboard/analytics-dashboard"
          element={<AnalyticsDashboard />}
        />
        <Route
          path="/dashboard/analytics-dashboardtwo"
          element={<AnalyticsDashboardTwo />}
        />
      </Routes>
    </BrowserRouter>
  );
}
